import { set as setApiMessages } from "@redux/modules/value/apiMessages/apiMessages.module";
import { broadcastMessage } from "@redux/modules/value/messages/messages.utils";

export const determineApiMessages = (cartMessages: any[], products: any) => {
    const transformedApiMessages = transformerApiMessages(
        cartMessages,
        products,
    );

    //Add to redux state to make accessible in component for displaying errors
    const store = window.storeManager;
    store.dispatch(setApiMessages({ data: transformedApiMessages }));

    renderApiMessages(transformedApiMessages);
};

export const transformerApiMessages = (cartMessages: any[], products: any) => {
    const transformedApiMessages = {
        general: cartMessages,
        products: [],
    };

    if (products) {
        products.forEach((product: any) => {
            if (product.messages) {
                product.messages.forEach((message: any) => {
                    message.sku = product.sku;
                    // @ts-ignore
                    transformedApiMessages.products.push(message);
                });
            }
        });
    }

    return transformedApiMessages;
};

const renderApiMessages = (transformedApiMessages: any) => {
    if (
        transformedApiMessages.general &&
        transformedApiMessages.general.length > 0 &&
        transformedApiMessages.general[0].code
    ) {
        broadcastMessage({
            id: "api-message",
            text: transformedApiMessages.general,
            status: "danger",
            dismissible: false,
        });
    }
};
